const DeActivateAccount = () => {
  return (
    <>
      <div className=" display-max main-page">
        <h1>Deactivate Account</h1>
      </div>
      <div className=" display-mini display-mob">
        <h1>Deactivate Account</h1>
      </div>
    </>
  );
};

export default DeActivateAccount;
